import React, { useState } from 'react';
import { Button, Dialog, Box } from '@mui/material';

const DigitDialogPanel = ({ open, onClose, onButtonClick }) => {
    const buttons = Array.from({ length: 20 }, (_, i) => i + 1);

    const handleClick = (number) => {
        onButtonClick(number);
        onClose(); // Закрыть диалог при нажатии на кнопку
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)', // 4 колонки
                    gap: 1,
                    margin: '0 auto',
                    padding: 1,
                }}
            >
                {buttons.map((number) => (
                    <Button
                        key={number}
                        variant="contained"
                        onClick={() => handleClick(number)}
                    >
                        {number}
                    </Button>
                ))}
            </Box>
        </Dialog>
    );
};

const DigitDialog  = ( { button_label, setFn }) =>{
    const [openDialog, setOpenDialog] = useState(false);
    const handleOpenDialog = () => {
        setOpenDialog(true);
    };
    const handleCloseDialog = () => {
        setOpenDialog(false);
    };
    const handleButtonClick = (num) => {
        setFn(num)
    };
    return(
        <>
            <Button
                onClick={handleOpenDialog}
            >{button_label}</Button>
            <DigitDialogPanel
                open={openDialog}
                onClose={handleCloseDialog}
                onButtonClick={handleButtonClick}
            />
        </>

    )

}

export default DigitDialog;
